import React from 'react';
import { IStyle } from 'Styles';
import { InputWithIcon } from 'components/input';
import { FormActionButton } from 'components/Button';

interface Props {
  handleSave: () => void;
  handleSetPasswordDetail: (e: any) => void;
  passwordDetail: any;
}

const ChangePasswordForm = (props: Props) => {
  const { handleSave, handleSetPasswordDetail, passwordDetail } = props;

  return (
    <>
      <div id="changepassword-newpassword-message">
        Please enter your new password to access ROCK MAKER.
      </div>
      <div id="changepassword-newpassword-wrapper" style={styles.fields}>
        <InputWithIcon
          name={'password'}
          value={passwordDetail.password}
          onChange={handleSetPasswordDetail}
          inputStyle={styles.input}
          inputType="password"
          placeholder="Password..."
          autoComplete="new-password"
        />
        <InputWithIcon
          name={'confirmPassword'}
          value={passwordDetail.confirmPassword}
          onChange={handleSetPasswordDetail}
          inputStyle={styles.input}
          inputType="password"
          placeholder="Confirm password..."
          autoComplete="new-password"
        />
        <div
          id="changepassword-newpassword-confirm-actionbutton"
          style={styles.actionButtons}
        >
          <FormActionButton
            onSaveClick={handleSave}
            saveText={'CONFIRM'}
            saveDisabled={
              passwordDetail.password != passwordDetail.confirmPassword ||
              passwordDetail.password == ''
            }
          />
        </div>
      </div>
    </>
  );
};

const styles: IStyle = {
  actionButtons: {
    width: '100%',
  },
  fields: {
    display: 'flex',
    margin: 10,
    gap: 20,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default ChangePasswordForm;
